import { TripAddress } from '../../lib/types/models/trip-address/trip-address'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripAddress(id: number) {
  return restApiClient.url(constructApiUrl(API.tripAddresses.get.url, { id })).get<TripAddress>()
}
